import { RootState } from '..';

export type User = RootState['user'];

export const userSelector = ({ user }: RootState): User => user;
